import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const ThankYouScreen = ({ onReturn, selectedRating, phoneNumber }) => {
  const [countdown, setCountdown] = useState(15);

  // Format phone number to (xxx) xxx-xxxx
  const formatPhoneNumber = (phone) => {
    if (!phone) return '';
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 10) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
    return phone; // Return original if not 10 digits
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          onReturn();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [onReturn]);

  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6 }
    },
    exit: { 
      opacity: 0, 
      y: -20,
      transition: { duration: 0.3 }
    }
  };

  const emojiVariants = {
    hidden: { scale: 0, rotate: -180 },
    visible: { 
      scale: 1, 
      rotate: 0,
      transition: { 
        type: "spring", 
        stiffness: 200, 
        damping: 10,
        delay: 0.2
      }
    }
  };

  const contentVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6, delay: 0.4 }
    }
  };

  const titleVariants = {
    hidden: { opacity: 0, scale: 1 },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: { 
        duration: 0.6, 
        delay: 0.4,
        scale: {
          duration: 1,
          times: [0, 0.25, 0.5, 0.75, 1],
          values: [1, 1.1, 1, 1.1, 1]
        }
      }
    }
  };

  const countdownVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: { duration: 0.3, delay: 0.6 }
    }
  };

  return (
    <motion.div 
      className="thank-you-screen"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <div className="thank-you-content">
        <motion.div 
          className="thank-you-emoji"
          variants={emojiVariants}
          initial="hidden"
          animate="visible"
        >
          <img 
            src="/Emojis/thank_you.gif" 
            alt="Thank you"
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'contain',
              maxWidth: '200px',
              maxHeight: '200px',
              borderRadius: '8px'
            }}
          />
        </motion.div>
        
        <motion.h2
          variants={titleVariants}
          initial="hidden"
          animate="visible"
        >
          Thank you for your feedback!
        </motion.h2>
        
        <motion.p
          variants={contentVariants}
          initial="hidden"
          animate="visible"
        >
          {phoneNumber 
            ? `We have your phone number ${formatPhoneNumber(phoneNumber)} and our management team will contact you soon to resolve this issue.`
            : selectedRating === 'very-satisfied'
            ? 'Thank you for your positive feedback! Your review helps us improve our service.'
            : 'Your opinion helps us improve our service.'
          }
        </motion.p>
        
        <motion.div 
          className="countdown-text"
          variants={countdownVariants}
          initial="hidden"
          animate="visible"
        >
          Returning to feedback screen in <span id="countdownNumber">{countdown}</span> seconds...
        </motion.div>
        
        <motion.button 
          className="return-button"
          onClick={onReturn}
          whileHover={{ y: -2, boxShadow: "0 8px 25px rgba(102, 126, 234, 0.4)" }}
          whileTap={{ scale: 0.98 }}
          variants={contentVariants}
          initial="hidden"
          animate="visible"
        >
          Submit Another Review
        </motion.button>
      </div>
    </motion.div>
  );
};

export default ThankYouScreen;
